import i18n from 'i18next';
import { isNull, isUndefined } from 'lodash';
import { initReactI18next } from 'react-i18next';
import { de } from './locale/de';
import { dk } from './locale/dk';
import { en } from './locale/en';
import { fr } from './locale/fr';
import { nl } from './locale/nl';

const bundles = {
  en,
  nl,
  de,
  dk,
  fr
};

const supportedLocales = Object.keys(bundles);

// Components call useTranslation(localStorage.getItem('locale')), so the namespace is the locale.
// react-i18next keeps `t` bound to the namespace of an earlier render; when the locale changes
// (login, or another browser tab) a component can briefly render with the old namespace, which
// does not exist under the new language and shows raw keys. Registering each language's bundle
// under every namespace name makes the namespace irrelevant: text always follows i18n.language.
// The bundles are shared references, nothing is copied.
const resources = supportedLocales.reduce((acc, lng) => ({
  ...acc,
  [lng]: supportedLocales.reduce((nsAcc, ns) => ({ ...nsAcc, [ns]: bundles[lng] }), {})
}), {});

const hostName = window.location.hostname;
let defaultLanguage = '';
if (!isUndefined(process.env.REACT_APP_DEFAULT_LOCALE) && !isNull(process.env.REACT_APP_DEFAULT_LOCALE)) {
  defaultLanguage = process.env.REACT_APP_DEFAULT_LOCALE;
} else if (hostName?.indexOf('baxi') !== -1) {
  defaultLanguage = 'en';
} else if (hostName?.indexOf('diemabox') !== -1) {
  defaultLanguage = 'fr';
} else if (hostName?.indexOf('fortes.it22.cloud') !== -1) {
  defaultLanguage = 'en';
} else {
  defaultLanguage = 'nl';
}

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('locale') || defaultLanguage,
    fallbackLng: defaultLanguage,
    interpolation: {
      escapeValue: false
    }
  });

// localStorage.locale is shared across browser tabs, while each tab's i18n.language is its own.
// When another tab changes the locale, switch this tab's language too so its text follows.
// The 'storage' event only fires in tabs other than the one that wrote the value.
window.addEventListener('storage', (event: StorageEvent) => {
  if (event.key !== 'locale') {
    return;
  }

  const newLocale = event.newValue;
  if (newLocale && supportedLocales.includes(newLocale) && newLocale !== i18n.language) {
    i18n.changeLanguage(newLocale);
  }
});
